import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskReturnPage = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskReturnPage;
